import React, { FC } from 'react';
import styles from './DribbbleIcon.scss';

export const DribbbleIcon: FC = () => <div className={styles.dribbbleIcon} />;
